var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ficha-foto galeria-aves"},[_c('img',{staticClass:"foto",attrs:{"src":_vm.publicPath+_vm.cover,"alt":""}}),_c('div',{staticClass:"degradado-aves"}),_c('div',{staticClass:"cuadro-contraste-aves"}),_c('p',{staticClass:"pie-foto"},[_vm._v(_vm._s(_vm.name)+" "),_c('i',[_vm._v(_vm._s(_vm.namec))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }